/* MetroPD Motors — Theme JS */

(function () {
  'use strict';

  /* ── Filter Tags ── */
  document.querySelectorAll('.filter-tag').forEach(tag => {
    tag.addEventListener('click', () => {
      tag.closest('.filter-tags').querySelectorAll('.filter-tag').forEach(t => t.classList.remove('is-active'));
      tag.classList.add('is-active');
    });
  });

  /* ── Cart Update ── */
  const cartForm = document.getElementById('cart-form');
  if (cartForm) {
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(input => {
      input.addEventListener('change', () => {
        document.getElementById('update-cart')?.click();
      });
    });
  }

  /* ── Add to Cart Ajax (product grid) ── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-atc');
    if (!btn) return;

    const variantId = btn.getAttribute('data-variant');
    if (!variantId) return;

    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (res.ok) {
        btn.textContent = 'Added!';
        btn.style.background = '#00d4ff';
        btn.style.color = '#0a0b0e';

        const cartData = await fetch('/cart.js').then(r => r.json());
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cartData.item_count;
        });
      } else {
        btn.textContent = 'Error';
      }
    } catch (err) {
      console.error('Add to cart failed:', err);
      btn.textContent = 'Error';
    }

    setTimeout(() => {
      btn.textContent = original;
      btn.style.background = '';
      btn.style.color = '';
      btn.disabled = false;
    }, 2000);
  });

  /* ── Sticky header shadow ── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 32px rgba(16,64,255,0.12)'
        : 'none';
    }, { passive: true });
  }

})();
